import { render, staticRenderFns } from "./keyword-metrics-app.vue?vue&type=template&id=76052dfe"
import script from "./keyword-metrics-app.vue?vue&type=script&lang=js"
export * from "./keyword-metrics-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports